import {documentsInDb} from '../document/FakeDocumentService';

export const documentRemindersInDb = [];

for (let i = 0; i < 3; i++) {
  documentRemindersInDb.push({
    id: 13401 + i,
    remindedOrganisationId: 1,
    remindedOrganisationName: 'Organisation 1',
    projectId: 1,
    projectName: 'Projet Standard',
    reason: 'PAYMENT',
    additionalContext: 'Lorem ipsum dolor sit amet',
    remindDate: `2019-08-2${i.toString()}T15:50:40Z`,
    status: 'OPEN',
    documents: [
      {
        correlationId: documentsInDb[0].correlationId,
        documentState: documentsInDb[0].state,
        uid: documentsInDb[0].uid
      },
      {
        correlationId: documentsInDb[1].correlationId,
        documentState: documentsInDb[1].state,
        uid: documentsInDb[1].uid
      },
      {
        correlationId: documentsInDb[2].correlationId,
        documentState: documentsInDb[2].state,
        uid: documentsInDb[2].uid
      }
    ]
  });
}

export default class FakeDocumentReminderService {
  getDocumentRemindersBySubcontractor(test1, test2, page) {
    return new Promise(resolve => {
      setTimeout(() => {
        resolve({
          reminders: [documentRemindersInDb[page]],
          totalCount: 47
        });
      }, 0);
    });
  }

  getDocumentsByReminder() {
    return new Promise(resolve => {
      setTimeout(() => {
        resolve(documentsInDb.slice(0, 3));
      }, 0);
    });
  }
}
